var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0579 8.47526C15.0579 6.83976 14.4082 5.27124 13.2518 4.11477C12.0953 2.95829 10.5268 2.30859 8.89128 2.30859M15.0579 8.47526H2.72461M15.0579 8.47526C15.0579 10.1108 14.4082 11.6793 13.2518 12.8358C12.0953 13.9922 10.5268 14.6419 8.89128 14.6419M8.89128 2.30859C7.25577 2.30859 5.68726 2.95829 4.53078 4.11477C3.37431 5.27124 2.72461 6.83976 2.72461 8.47526M8.89128 2.30859C8.55794 2.30859 6.22461 5.06926 6.22461 8.47526C6.22461 11.8813 8.55794 14.6419 8.89128 14.6419M8.89128 2.30859C9.22461 2.30859 11.5579 5.06926 11.5579 8.47526C11.5579 11.8813 9.22461 14.6419 8.89128 14.6419M2.72461 8.47526C2.72461 10.1108 3.37431 11.6793 4.53078 12.8358C5.68726 13.9922 7.25577 14.6419 8.89128 14.6419",
    stroke: "#FD4319",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.4acc772bd29eacb9f00e8e10fc6e9691.svg";
export { ForwardRef as ReactComponent };